export * from './baMenu.service';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/services/baMenu/index.ts